{
  "version": 1,
  "asset_id": "7788b53e-7424-4078-94c0-b96b304dbed7",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7788b53e-7424-4078-94c0-b96b304dbed7/ind-hvac-home-services-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7788b53e-7424-4078-94c0-b96b304dbed7/ind-hvac-home-services-640.avif",
  "original_filename": "ind-hvac-home-services-640.avif",
  "size": 6883,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:05Z"
}
